class CountdownTimer extends HTMLElement {
    constructor() {
        super();

        // Initialize countdown elements
        this.countdownElements = {
            days: this.querySelector('#times_day'),
            hours: this.querySelector('#times_hour'),
            minutes: this.querySelector('#times_minute'),
            seconds: this.querySelector('#times_second')
        };

        // Initialize targetDate from data-date attribute
        this.targetDate = new Date(this.getAttribute("data-date")).getTime();
        this.updateCountdown();

        // Update every second
        setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
        const now = new Date().getTime();
        const timeRemaining = this.targetDate - now;

        if (timeRemaining <= 0) {
            // Countdown is over
            this.resetCountdown();
        } else {
            // Calculate remaining days, hours, minutes, and seconds
            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            // Update countdown elements directly
            this.updateElement(this.countdownElements.days, days.toString().padStart(2, '0'));
            this.updateElement(this.countdownElements.hours, hours.toString().padStart(2, '0'));
            this.updateElement(this.countdownElements.minutes, minutes.toString().padStart(2, '0'));
            this.updateElement(this.countdownElements.seconds, seconds.toString().padStart(2, '0'));
        }
    }

    updateElement(element, value) {
        if (element) {
            element.textContent = value;
        }
    }

    resetCountdown() {
        // Countdown is over, reset to 00:00:00:00
        for (const key in this.countdownElements) {
            this.updateElement(this.countdownElements[key], '00');
        }
    }
}

// Define custom element
customElements.define('countdown-timer', CountdownTimer);
